module.exports = __webpack_public_path__ + "static/media/Graphical_abstract-NTPDase3_thb.523a883f.jpg";